// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub[data-v-66e7a411] {\n  color: #909399;\n  font-size: 12px;\n  margin-left: 8px;\n}\n.block[data-v-66e7a411] {\n  margin-top: 12px;\n  text-align: right;\n}\n.tips[data-v-66e7a411] {\n  color: #909399;\n  font-size: 12px;\n  line-height: 20px;\n  margin-top: 12px;\n}", ""]);
// Exports
module.exports = exports;
